import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth"
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyDt6-8LXz4Dlp__4r7IVzk49Qe_YGM-GsQ",
  authDomain: "upskillinstitute-au.firebaseapp.com",
  projectId: "upskillinstitute-au",
  storageBucket: "upskillinstitute-au.appspot.com",
  messagingSenderId: "774591921783",
  appId: "1:774591921783:web:6d9ad2c13f261ea01d1072",
  measurementId: "G-VMYXK974LM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)

// Emulator wiring exists only for isolated acceptance testing. Both guards must hold:
// the build must opt in through REACT_APP_FIREBASE_EMULATORS ("authPort,firestorePort"),
// and the page must be served from a loopback host. A deployed site therefore cannot be
// pointed at an emulator by a stray build variable, which would silently detach real
// students from production data.
const emulatorPorts = String(process.env.REACT_APP_FIREBASE_EMULATORS || '').trim();
const servedLocally = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1', '[::1]', '::1'].includes(window.location.hostname);
if (emulatorPorts && servedLocally) {
  const [authPort, firestorePort] = emulatorPorts.split(',').map(value => Number(value.trim()));
  if (Number.isInteger(authPort) && authPort > 0) connectAuthEmulator(auth, `http://127.0.0.1:${authPort}`, { disableWarnings: true });
  if (Number.isInteger(firestorePort) && firestorePort > 0) connectFirestoreEmulator(db, '127.0.0.1', firestorePort);
}